<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mt-sm-0 mb-2">
      <v-flex>
        <h2 class="dark--text font-weight-bold">Payment Gateway Charges</h2>
      </v-flex>
      <v-spacer></v-spacer>

      <AddGatewayCharge />

      <!-- <app-faq-form v-if="hasRole(AdminUserPermissions.FAQ_ADD)"></app-faq-form> -->
    </v-layout>
    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="itemsWithSno" class="elevation-1" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
      <template v-slot:item.transactionCharge="{ item }"> {{ item.transactionCharge }} {{ item.isInPercentage ? " %" : "" }} </template>
      <template v-slot:item.actions="{ item }">
        <GatewayChargeUpdateForm :data="item" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import GatewayChargeUpdateForm from "../components/GatewayChargeUpdateForm.vue";
import AddGatewayCharge from "../components/AddGatewayCharge.vue";
export default {
  components: {
    GatewayChargeUpdateForm,
    AddGatewayCharge,
  },
  methods: {},
  data: () => ({
    loading: true,
    gatewayCharges: [],
    headers: [
      {
        text: "#",
        value: "slNo",
        sortable: false,
        width: 90,
      },
      { text: "Gateway", value: "gateway", width: 200, sortable: false },
      {
        text: "Transaction Type",
        value: "transactionType",
        width: 150,
        sortable: false,
      },

      {
        text: "Transaction Charge",
        value: "transactionCharge",
        sortable: false,
        width: 120,
      },
      { text: "Action", value: "actions", sortable: false, width: 90 },
    ],
  }),
  apollo: {
    getAllFaqs() {
      // console.log("djfd");
      return {
        query: require("../api/getPaymentGatewayCharges.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.gatewayCharges = data.getPaymentGatewayCharges;
        },
      };
    },
  },
  computed: {
    itemsWithSno() {
      if (this.gatewayCharges == null) return [];
      return this.gatewayCharges.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  created() {
    // if (!this.hasRole(this.AdminUserPermissions.FAQ_VIEW)) {
    //   this.$router.push({
    //     name: "Error404",
    //   });
    // }
  },
};
</script>
